module.exports = __webpack_public_path__ + "img/icon-escalated.1d4563ce.svg";